export const phrase = {
  correct: {en: 'correct', de: 'richtig'},
  wrong: {en: 'wrong', de: 'falsch'},
  continue: {en: 'continue', de: 'Weiter'},
  solution: {en: 'solution', de: 'Lösung'},
  eblQuestion: {en: 'Example', de: 'Aufgabe'},
  editablePlaceholder: {en: 'Please enter here...', de: 'Bitte hier eingeben...'},
  formulaPlaceholder: {
    en: 'Type fractions with &quot;/&quot; as in 1/2',
    de: 'Brüche mit &quot;/&quot; eingeben, z.B. 1/2 ...'
  },
  continueText: {en: 'Please press SPACE to continue...', de: 'Weiter mit der Leertaste ...'},
  continueButton: {en: 'continue...', de: 'Weiter...'},
  cancelButton: {en: 'stop...', de: 'Abbrechen...'},
  sessionFinishedDu: {
    en: '<p>Thank you very much for participating in our study.</p> <p>The experiment is finished.</p>',
    de: '<p>Das Experiments ist bereits vollständig abgeschlossen.</p> <p>Vielen Dank, dass du an der Studie teilgenommen hast.</p> <p>Du kannst den Browser jetzt schließen.</p>',
  },
  sessionFinishedSie: {
    en: 'Thank you very much for participating in our study. This part of the experiment is finished.',
    de: 'Dieser Teil des Experiments ist beendet. Vielen Dank, dass Sie an der Studie teilgenommen haben. Sie können das Fenster jetzt schließen.',
  },
  pending: {
    en: 'The next part of the experiment has not been activated yet.',
    de: 'Die nächste Phase des Experiments ist noch nicht freigeschaltet.',
  },
  pendingTime: {
    en: 'Time remaining: ',
    de: 'Verbleibende Wartezeit: ',
  },
}



